<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            Import Users
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <v-row justify="center" class="my-5">
      <v-col cols="12" sm="4">
        <v-card class="elevation-card rounded-12 mb-5">
          <v-card-title>
            <v-icon color="primary2" class="mr-2">
              mdi-web
            </v-icon>
            <span class="fs-14 font-weight-bold primary2--text">
              Import Users
            </span>
            <v-spacer />
          </v-card-title>
          <v-divider />
          <validation-observer v-slot="{ handleSubmit }">
            <form class="pa-4" @submit.prevent="handleSubmit(login)">
              <v-alert class="fs-14" type="error" v-if="error">
                {{ error }}
              </v-alert>
              <v-alert class="fs-14" type="success" v-if="success">
                {{ success }}
              </v-alert>
              <ValidationProvider
                slim
                name="File"
                rules="required"
                v-slot="{ errors }"
              >
                <label
                  class="mb-1 d-block fs-12 font-weight-regular"
                  for="file"
                >
                  File
                </label>
                <v-file-input
                  id="file"
                  single-line
                  dense
                  outlined
                  :error-messages="errors"
                  prepend-icon=""
                  prepend-inner-icon="mdi-attachment"
                  placeholder="Select File"
                  v-model="file"
                ></v-file-input>
              </ValidationProvider>
              <v-btn
                :loading="loading"
                type="submit"
                large
                block
                color="primary"
              >
                Import
              </v-btn>
            </form>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    error: '',
    success: '',

    file: null,

    breadcrumbs: [
      {
        text: 'SSHCF',
        to: '/'
      },
      {
        text: 'Import Users',
        disabled: false
      }
    ]
  }),
  methods: {
    async login() {
      this.loading = true;

      const data = new FormData();
      data.append('user', this.file);

      const res = await this.$store.dispatch('sshcf/importUsers', data);
      this.loading = false;

      if (res.code === 200) {
        this.file = null;
        this.success = res.message.text_en;
      } else {
        this.error = res.message.text_en;
      }
    }
  }
};
</script>

<style scoped></style>
